import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { Button } from '../../components/ui/button';
import { LanguageSwitcher } from '../../components/LanguageSwitcher';
import { Logo } from '../../components/common/Logo';
import { Moon, Sun, LogOut, Printer } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import WaiterTables from './WaiterTables';
import WaiterOrder from './WaiterOrder';
import WaiterPrinter from './WaiterPrinter';

export default function WaiterApp() {
  const { t } = useTranslation();
  const { user, logout, setUiLanguage } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  return (
    <div className="min-h-dvh bg-background flex flex-col">
      <header className="h-14 shrink-0 border-b border-border bg-card flex items-center gap-2 px-4 sticky top-0 z-30">
        <Logo className="h-9 w-9" />
        <div>
          <div className="font-display font-semibold text-sm leading-tight">{t('waiter.title')}</div>
          <div className="text-xs text-muted-foreground leading-tight">{user?.name}</div>
        </div>
        <div className="ml-auto flex items-center gap-1">
          <Button variant="ghost" size="icon" onClick={() => navigate('/waiter/printer')} data-testid="waiter-printer-nav" title={t('waiterPrinter.title', { defaultValue: 'Stampante cameriere' })}><Printer className="h-5 w-5" /></Button>
          <LanguageSwitcher variant="compact" onChange={(code) => setUiLanguage(code)} />
          <Button variant="ghost" size="icon" onClick={toggleTheme}>{theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}</Button>
          <Button variant="ghost" size="icon" onClick={logout} data-testid="waiter-logout-button" className="text-destructive"><LogOut className="h-5 w-5" /></Button>
        </div>
      </header>
      <div className="flex-1">
        <Routes>
          <Route index element={<WaiterTables />} />
          <Route path="order/:tableId" element={<WaiterOrder />} />
          <Route path="printer" element={<WaiterPrinter />} />
        </Routes>
      </div>
    </div>
  );
}
